import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Auth/Login.vue";
// import Register from "../views/Auth/Register.vue";
import ForgetPassword from "../views/Auth/ForgetPassword.vue";
import ResetPassword from "../views/Auth/ResetPassword.vue";
import authenticated from "../middleware/authenticated";
import DashboardLayout from "@/views/Layouts/DashboardLayout.vue"
import DashboardRoute from "./DashboardRoute";

Vue.use(VueRouter);

const routes = [
    {
        path: "",
        component: DashboardLayout,
        children: [...DashboardRoute]
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            middleware: authenticated,
        }
    },
    // {
    //     path: "/register",
    //     name: "Register",
    //     component: Register,
    //     meta: {
    //         middleware: authenticated,
    //     }
    // },
    {
        path: "/forget-password",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
            middleware: authenticated,
        }
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            middleware: authenticated,
        }
    },
];


const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
});

export default router;